import { useState, useEffect } from "react";

const OtpCountdown = ({ otpExpiry }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  // Convert backend string to seconds
  useEffect(() => {
    if (!otpExpiry) return;

    // Extract number (minutes) from string, e.g., "29 دقيقة من الآن"
    const match = otpExpiry.match(/(\d+)/);
    const minutes = match ? parseInt(match[1], 10) : 0;

    setTimeLeft(minutes * 60); // convert minutes → seconds
  }, [otpExpiry]);

  // Countdown timer
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="text-success mt-1">
      {timeLeft > 0
        ? `ينتهي OTP خلال: ${minutes} دقيقة ${seconds} ثانية`
        : ""}
    </div>
  );
};

export default OtpCountdown;